import React from 'react'
import { Button } from '@/components/ui/button'
import AvatarListCard from './AvatarListCard'
import type { AvatarListItem } from '../utils/avatarList'

type Props = {
  items: AvatarListItem[]
  hasMore?: boolean
  loadingNext?: boolean
  onLoadNext?: () => void
}

export default function AvatarListGrid({
  items,
  hasMore = false,
  loadingNext = false,
  onLoadNext,
}: Props) {
  if (!items.length) {
    return (
      <div className="flex flex-1 items-center justify-center p-8 text-sm text-muted-foreground">
        暂无 Avatar 数据
      </div>
    )
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="min-h-0 flex-1 overflow-y-auto p-4">
        <div className="grid auto-rows-max grid-cols-1 gap-4 md:grid-cols-2">
          {items.map((item, index) => (
            <AvatarListCard
              key={`${item.listType ?? 'avatar'}-${item.id}-${index}`}
              item={item}
            />
          ))}
        </div>
      </div>

      {onLoadNext ? (
        <div className="flex shrink-0 flex-col items-center gap-2 border-t px-4 py-3">
          <Button
            variant="outline"
            onClick={onLoadNext}
            disabled={!hasMore || loadingNext}
          >
            {loadingNext ? '加载中…' : '加载下一页'}
          </Button>
          {!hasMore ? (
            <p className="text-xs text-muted-foreground">没有更多了</p>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
